import { FontWeight } from "../data";

export const fontWeightEnum: Record<FontWeight, number> | any = {
  heavy: 900,
  medium: 500,
  normal: 350,
};
